/**
 *
 * Asynchronously loads the component for AccountLayoutPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'), {
  fallback: null,
});
